export const vehiclePlotTags={
    1: "Vehicle interest",
    2: "Vehicle loan",
   
};

export const propertyPlotTags={
    1: "Propery interest",
    2: "Property loan",
};